import TestHistorySection from "./models/TestHistorySection"
import { ObservableFromFetch } from "./ObservableFromFetch"

export const getHistory = (showPhysicalFirst: boolean) => ObservableFromFetch<TestHistorySection[]>(`History?showPhysicalFirst=${showPhysicalFirst}`)
